import { html } from 'omni-ui';
import { Om2FormFieldBase } from './common/base.js';

/**
 * Render a horizontal rule (<hr>)
 * This is a layout field, not an input field.
 */
export class Om2FormFieldHorizontalRule extends Om2FormFieldBase {
  static metadata = {
    layout: true,
    config: {
      maxContents: 0,
      label: 'horizontal rule',
      fields: {
        class: {
          title: 'CSS Class',
          tooltip:
            'This is a space separated list of css classes (typically from bulma/omni-ui)',
          type: 'string',
        },
      },
    },
  };

  render() {
    const { schema } = this;
    return html`<hr class=${schema.class} />`;
  }
}

Om2FormFieldHorizontalRule.register('horizontal-rule');
